module.exports = __webpack_public_path__ + "img/upgrade-to-pro-line.7bcefc4b.svg";